import { render, staticRenderFns } from "./CallingCourierPopup.vue?vue&type=template&id=5d13b5dc"
import script from "./CallingCourierPopup.vue?vue&type=script&lang=js"
export * from "./CallingCourierPopup.vue?vue&type=script&lang=js"
import style0 from "./CallingCourierPopup.vue?vue&type=style&index=0&id=5d13b5dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports